'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.normalize = exports.strictlyBefore = exports.getTime = exports.findInsertionIndex = exports.Index = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _momentTimezone = require('moment-timezone');

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Index = exports.Index = function () {
    /**
     * @param index           Integer
     * @param isDummyBefore   Boolean
     */
    function Index(index, isDummyBefore) {
        _classCallCheck(this, Index);

        this.index = index;
        this.isDummyBefore = isDummyBefore;
    }

    _createClass(Index, [{
        key: 'advance',
        value: function advance() {
            if (this.isDummyBefore) {
                this.isDummyBefore = false;
            } else {
                this.isDummyBefore = true;
                ++this.index;
            }
        }
    }]);

    return Index;
}();

/**
 * @param timeWindows   List<DateTimeWindow>
 * @param timestamp     Long
 * @param tz            Timezone
 * @return Index
 */


var findInsertionIndex = exports.findInsertionIndex = function findInsertionIndex(timeWindows, timestamp, tz) {
    // TODO: use binary search
    for (var i = 0, l = timeWindows.length; i < l; ++i) {
        var timeWindow = timeWindows[i];

        var c = compare(timestamp, timeWindow, tz);
        if (c < 0) {
            return new Index(i, true);
        }if (c === 0) {
            return new Index(i, false);
        }
    }
    return new Index(timeWindows.length, true);
};

/**
 * @param date   availability.Date
 * @return Long
 */
var getTime = exports.getTime = function getTime(date, tz) {
    if (!date) {
        return null;
    }
    return _momentTimezone2.default.tz([date.year, date.month - 1, date.day, date.hour, date.minute], tz).valueOf();
};

var strictlyBefore = exports.strictlyBefore = function strictlyBefore(window1EndTs, window2StartTs) {
    if (window1EndTs === null || window2StartTs === null) {
        return false;
    }
    return window1EndTs <= window2StartTs;
};

var compare = function compare(timestamp, timeWindow, tz) {
    if (strictlyBefore(timestamp + 1000, getTime(timeWindow.start, tz))) {
        return -1;
    } else if (strictlyBefore(getTime(timeWindow.end, tz), timestamp)) {
        return 1;
    } else {
        return 0;
    }
};

/**
 * Maps each availability.Date to a Long value, for easy comparison.
 *
 * @param date      availability.Date
 * @param isStart   Boolean; Does the date argument represent 'start' or 'end'
 * @return Long
 */
var dateToNum = function dateToNum(date, isStart) {
    if (!date) {
        return isStart ? Number.NEGATIVE_INFINITY : Number.POSITIVE_INFINITY;
    } else {
        return date.year * 60 * 60 * 60 * 32 * 366 + date.month * 60 * 60 * 32 + date.day * 60 * 60 + date.hour * 60 + date.minute;
    }
};

var normalize = exports.normalize = function normalize(timeWindows) {
    var separators = _lodash2.default.reduce(timeWindows, function (acc, timeWindow) {
        if (timeWindow.start) {
            acc.points.push(timeWindow.start);
        } else {
            acc.hasSinceForever = true;
        }
        if (timeWindow.end) {
            acc.points.push(timeWindow.end);
        } else {
            acc.hasUntilForever = true;
        }

        return acc;
    }, {
        hasSinceForever: false,
        hasUntilForever: false,
        points: []
    });

    var sortedUniquePoints = (0, _lodash2.default)(separators.points).sortBy(function (point) {
        return dateToNum(point, true);
    }).sortedUniqBy(function (point) {
        return dateToNum(point, true);
    }).value();

    // Convert list to sorted non-overlapping windows
    var normalizedTimeWindows = [];
    if (separators.hasSinceForever) {
        if (sortedUniquePoints.length > 0) {
            normalizedTimeWindows.push({
                start: null,
                end: sortedUniquePoints[0]
            });
        } else if (separators.hasUntilForever) {
            normalizedTimeWindows.push({
                start: null,
                end: null
            });
        }
    }

    for (var i = 0; i < sortedUniquePoints.length - 1; ++i) {
        normalizedTimeWindows.push({
            start: sortedUniquePoints[i],
            end: sortedUniquePoints[i + 1]
        });
    }

    if (separators.hasUntilForever) {
        if (sortedUniquePoints.length > 0) {
            normalizedTimeWindows.push({
                start: sortedUniquePoints[sortedUniquePoints.length - 1],
                end: null
            });
        }
    }

    // Assign availability to windows, omit unknowns
    return (0, _lodash2.default)(normalizedTimeWindows).map(function (normalizedTimeWindow) {
        var normalizedStart = dateToNum(normalizedTimeWindow.start, true);
        var normalizedEnd = dateToNum(normalizedTimeWindow.end, false);

        var timeWindow = _lodash2.default.findLast(timeWindows, function (timeWindow) {
            return normalizedStart >= dateToNum(timeWindow.start, true) && normalizedEnd <= dateToNum(timeWindow.end, false);
        });

        return timeWindow ? _lodash2.default.defaults(normalizedTimeWindow, timeWindow) : null;
    }).compact().value();
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/availability/dist/iterators/DateTimeWindowsUtils.js
// module id = 368
// module chunks = 0